import { createSelector } from '@ngrx/store';
import {
  QUESTIONNAIRE_FEATURE_KEY,
  questionnaireFeatureState,
} from '@retention/shared';

export const getSelectedState = createSelector(
  questionnaireFeatureState,
  (state) => state[QUESTIONNAIRE_FEATURE_KEY]
);

export const getQuestionnaireResults = createSelector(
  getSelectedState,
  (state) => state.questionnaireResults
);

export const getActiveStep = createSelector(
  getSelectedState,
  (state) => state.activeStep
);

export const questionnaireStartVM = createSelector(
  getActiveStep,
  getQuestionnaireResults,
  (activeStep, questionnaireResults) => ({
    activeStep,
    questionnaireResults,
  })
);
